import { useCallback } from 'react';
import { useUpdateAnalysisInfo } from '../../../utils/hooks';
import toastMessage from '../../../utils/toastMessage';
import useAnalysisSetChartPref from '../hooks/useAnalysisSetChartPref';
import { useChartContext } from '../ChartContext';
import useScratchpadAnalysis from './useScratchpadAnalysis';

const useSaveReportSettings = (analysisId: string) => {
  const setAnalysisChartPref = useAnalysisSetChartPref(analysisId);
  const {
    metadata: {
      display: currentDisplay,
      description: currentDescription,
      hasUpdateDisplayOrDescription,
    },
  } = useChartContext();
  const { refreshScratchpadAnalysis, isScratchpadAnalysisLoaded } =
    useScratchpadAnalysis({ analysisId });

  const { updateAnalysisInfo } = useUpdateAnalysisInfo({
    analysisId,
    currentName: currentDisplay,
    currentDescription,
  });

  // const handleLoadAnalysisInfo = ({ analysis }: IGetAnalysisInfoQuery) => {
  //   assertNotNil(analysis);
  //   dispatch(populateBuilderInfoAction({ analysisInfo: analysis }));
  // };

  // const [getAnalysisInfo] = useLazyQuery<
  //   IGetAnalysisInfoQuery,
  //   IGetAnalysisInfoQueryVariables
  // >(GET_ANALYSIS_INFO, {
  //   variables: {
  //     analysisId,
  //   },
  //   onCompleted: handleLoadAnalysisInfo,
  // });

  const saveReportSettings = useCallback(async () => {
    const errors = await setAnalysisChartPref();
    if (errors.length > 0) {
      toastMessage({ message: errors.join(', '), type: 'error' });
      return;
    }

    if (hasUpdateDisplayOrDescription) {
      await updateAnalysisInfo(currentDisplay, currentDescription);
    }

    // Refresh the scratchpad analysis if it exists
    if (isScratchpadAnalysisLoaded) {
      await refreshScratchpadAnalysis();
    }
    toastMessage({ message: 'Report settings saved', type: 'info' });
  }, [
    currentDisplay,
    currentDescription,
    isScratchpadAnalysisLoaded,
    updateAnalysisInfo,
    setAnalysisChartPref,
    refreshScratchpadAnalysis,
    hasUpdateDisplayOrDescription,
  ]);

  return {
    saveReportSettings,
  };
};

export default useSaveReportSettings;
